import ajax from './ajax'
import {webUrl} from './webUrl'

export const baseUrl = webUrl
// 登录
export const reqLogin = (username, password) => ajax(baseUrl + '/login', {username, password})
// 退出
export const reqLogout = () => ajax(baseUrl + '/logout', {})
// 获取国家列表
export const reqCountry = () => ajax(baseUrl + '/api/v1/p/country')
// 获取省列表
export const reqState = (parentId) => ajax(baseUrl + '/api/v1/p/state', {parentId})
// 获取城市列表
export const reqCity = (parentId) => ajax(baseUrl + '/api/v1/p/city', {parentId})

// 获取地址信息
export const reqAddress = (type) => ajax(baseUrl + '/api/v1/p/address', {type})
// 获取国家城市列表
export const reqArea = (type) => ajax(baseUrl + '/api/v1/p/area', {type});
// 新建委托单
export const reqSaveTrack = (po) => ajax(baseUrl + '/api/v1/p/oms/order', po, 'POST')
// 更新
export const reqUpdateTrack = (po) => ajax(baseUrl + '/api/v1/p/oms/order', po, 'PUT')
// 委托单列表
export const reqTrackList = (po) => ajax(baseUrl + '/api/v1/p/oms/orderList', po)

// 获取订单信息
export const getOrderDetails = (id) => ajax(baseUrl + '/api/v1/p/oms/order', {id})

// 查询轨迹号
export const getOrderDelivery = (orderId) => ajax(baseUrl + '/api/v1/p/orderDelivery', {orderId})

// 查询轨迹信息
export const getOrderTrails = (po) => ajax(baseUrl + '/api/v1/p/trails', po)

// 附件
export const reqFileList = (po) => ajax(baseUrl + '/api/v1/p/file/list', po)
export const reqSaveFile = (po) => ajax(baseUrl + '/api/v1/p/oms/orderFile', po, 'PUT')
export const reqFileDel = (po) => ajax(baseUrl + '/api/v1/p/file/fileDel', po, 'DELETE')
// 获取订单信息
export const getOrderShort = (id) => ajax(baseUrl + '/api/v1/p/oms/orderShort', {id})
// 进口订单详情
export const getImportOrderShort = (id) => ajax(baseUrl + "/api/v1/p/oms/importOrder/order", {id})
// 进口订单轨迹信息
export const getImportOrderTimes = (orderId) => ajax(baseUrl + "/api/v1/p/oms/import/optRecords", {orderId})

// 查询订单列表
export const getPublicOrderList = (type, recordNo) => ajax(baseUrl + '/d/public/orderList', {type, recordNo})

// 查询公共查询页面详情
export const getPublicOrderDetail = (orderNo) => ajax(baseUrl + '/d/public/order', {orderNo})

// 查询GPS信息
export const getPublicTrails = (po) => ajax(baseUrl + '/d/public/trails', po)

// 获取订单信息
export const getOrder = (id) => ajax(baseUrl + '/api/v1/p/oms/order', {id})
//订舱单
export const reqCabin = (orderId) => ajax(baseUrl + '/api/v1/p/oms/cabin', {orderId});
export const reqCreateCabin = (po) => ajax(baseUrl + '/api/v1/p/oms/cabin', po, 'POST');
export const reqUpdateCabin = (po) => ajax(baseUrl + '/api/v1/p/oms/cabin', po, 'PUT');
//发票
export const reqInvoice = (orderId) => ajax(baseUrl + '/api/v1/p/oms/invoice', {orderId});
export const reqCreateInvoice = (po) => ajax(baseUrl + '/api/v1/p/oms/invoice', po, 'POST');
export const reqUpdateInvoice = (po) => ajax(baseUrl + '/api/v1/p/oms/invoice', po, 'PUT');
//packingList
export const reqPackingList = (orderId) => ajax(baseUrl + '/api/v1/p/oms/packingList', {orderId});

//订单审核
export const reqReview = (orderId, type) => ajax(baseUrl + '/api/v1/p/oms/review', {orderId, type});
// 完成装箱
export const reqBoxComplete = (orderId) => ajax(baseUrl + '/api/v1/p/oms/packing', {orderId})

export const fileThumb = {
    word: "data:image/svg+xml;charset=utf8,%3Csvg%20t%3D%221574066820821%22%20class%3D%22icon%22%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20p-id%3D%229677%22%20width%3D%22200%22%20height%3D%22200%22%3E%3Cpath%20d%3D%22M854.6%20288.6L639.4%2073.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7%200-32%2014.3-32%2032v832c0%2017.7%2014.3%2032%2032%2032h640c17.7%200%2032-14.3%2032-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2%20326H602V137.8L790.2%20326z%20m1.8%20562H232V136h302v216c0%2023.2%2018.8%2042%2042%2042h216v494z%22%20p-id%3D%229678%22%20fill%3D%22%232975d5%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M528.1%20472h-32.2c-5.5%200-10.3%203.7-11.6%209.1L434.6%20680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4c-1.1%200-2.1%200.1-3.1%200.4-6.4%201.7-10.2%208.3-8.5%2014.7l74.2%20276c1.4%205.2%206.2%208.9%2011.6%208.9h32c5.4%200%2010.2-3.6%2011.6-8.9l52.8-197%2052.8%20197c1.4%205.2%206.2%208.9%2011.6%208.9h31.8c5.4%200%2010.2-3.6%2011.6-8.9l74.4-276c0.3-1%200.4-2.1%200.4-3.1%200-6.6-5.4-12-12-12H647c-5.6%200-10.4%203.9-11.7%209.3l-45.8%20199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z%22%20p-id%3D%229679%22%20fill%3D%22%232975d5%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E",
    excel: "data:image/svg+xml;charset=utf8,%3Csvg%20t%3D%221574066793618%22%20class%3D%22icon%22%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20p-id%3D%229447%22%20width%3D%22200%22%20height%3D%22200%22%3E%3Cpath%20d%3D%22M854.6%20288.6L639.4%2073.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7%200-32%2014.3-32%2032v832c0%2017.7%2014.3%2032%2032%2032h640c17.7%200%2032-14.3%2032-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2%20326H602V137.8L790.2%20326z%20m1.8%20562H232V136h302v216c0%2023.2%2018.8%2042%2042%2042h216v494z%22%20p-id%3D%229448%22%20fill%3D%22%232975d5%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M514.1%20580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3%200-4.5%200.6-6.4%201.9-5.6%203.5-7.3%2010.9-3.7%2016.6l82.3%20130.4-83.4%20132.8c-1.2%201.9-1.8%204.1-1.8%206.4%200%206.6%205.4%2012%2012%2012h34.5c4.2%200%208-2.2%2010.2-5.7L510%20664.8l62.3%20101.4c2.2%203.6%206.1%205.7%2010.2%205.7H620c2.3%200%204.5-0.7%206.5-1.9%205.6-3.6%207.2-11%203.6-16.6l-84-130.4%2085.3-132.5c1.2-1.9%201.9-4.2%201.9-6.5%200-6.6-5.4-12-12-12h-35.7c-4.2%200-8.1%202.2-10.3%205.8l-61.2%20102.3z%22%20p-id%3D%229449%22%20fill%3D%22%232975d5%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E",
    pdf: "data:image/svg+xml;charset=utf8,%3Csvg%20t%3D%221574066687493%22%20class%3D%22icon%22%20viewBox%3D%220%200%201024%201024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20p-id%3D%228801%22%20width%3D%22200%22%20height%3D%22200%22%3E%3Cpath%20d%3D%22M531.3%20574.4l0.3-1.4c5.8-23.9%2013.1-53.7%207.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-0.7-29.9%208.3-33.4%2021.4-6.6%2024-0.7%2056.8%2010.1%2098.6-13.6%2032.4-35.3%2079.5-51.2%20107.5-29.6%2015.3-69.3%2038.9-75.2%2068.7-1.2%205.5%200.2%2012.5%203.5%2018.8%203.7%207%209.6%2012.4%2016.5%2015%203%201.1%206.6%202%2010.8%202%2017.6%200%2046.1-14.2%2084.1-79.4%205.8-1.9%2011.8-3.9%2017.6-5.9%2027.2-9.2%2055.4-18.8%2080.9-23.1%2028.2%2015.1%2060.3%2024.8%2082.1%2024.8%2021.6%200%2030.1-12.8%2033.3-20.5%205.6-13.5%202.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6%20726.3c-13.9%2020.2-24.4%2030.3-30.1%2034.7%206.7-12.3%2019.8-25.3%2030.1-34.7z%20m87.6-235.5c5.2%208.9%204.5%2035.8%200.5%2049.4-4.9-19.9-5.6-48.1-2.7-51.4%200.8%200.1%201.5%200.7%202.2%202z%20m-1.6%20120.5c10.7%2018.5%2024.2%2034.4%2039.1%2046.2-21.6%204.9-41.3%2013-58.9%2020.2-4.2%201.7-8.3%203.4-12.3%205%2013.3-24.1%2024.4-51.4%2032.1-71.4z%20m155.6%2065.5c0.1%200.2%200.2%200.5-0.4%200.9h-0.2l-0.2%200.3c-0.8%200.5-9%205.3-44.3-8.6%2040.6-1.9%2045%207.3%2045.1%207.4z%22%20p-id%3D%228802%22%20fill%3D%22%232975d5%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M854.6%20288.6L639.4%2073.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7%200-32%2014.3-32%2032v832c0%2017.7%2014.3%2032%2032%2032h640c17.7%200%2032-14.3%2032-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2%20326H602V137.8L790.2%20326z%20m1.8%20562H232V136h302v216c0%2023.2%2018.8%2042%2042%2042h216v494z%22%20p-id%3D%228803%22%20fill%3D%22%232975d5%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E"
}
// 地址信息
export const reqAddresses = (po) => ajax(baseUrl + '/api/v1/p/addressList', po);
export const reqCreateAddress = (po) => ajax(baseUrl + '/api/v1/p/addressSave', po, 'POST');
export const reqUpdateAddress = (po) => ajax(baseUrl + '/api/v1/p/addressUpdate', po, 'PUT');
export const reqAddressInfo = (id) => ajax(baseUrl + '/api/v1/p/addressInfo', {id});

// 轨迹信息
export const reqPublicOptRecord = (orderNo) => ajax(baseUrl + '/d/public/optRecord', {orderNo});
export const reqOptRecord = (orderId) => ajax(baseUrl + '/api/v1/p/optRecord', {orderId});
export const reqRecordSave = (po) => ajax(baseUrl + '/api/v1/p/recordSave', po, 'POST');
export const reqOrderSendRecord = (po) => ajax(baseUrl + '/api/v1/p/order/recordSend', po, 'POST');
export const reqRecordUpdate = (po) => ajax(baseUrl + '/api/v1/p/recordUpdate', po, 'PUT');
export const reqRecordDel = (po) => ajax(baseUrl + '/api/v1/p/recordDel', po, 'DELETE2');
// 物流列表
export const reqLogisticsList = (data) => ajax(baseUrl + '/api/v1/p/oms/logisticsList', data);

// GPS设备号列表
export const reqDeviceList = (data) => ajax(baseUrl + '/api/v1/p/oms/devices', data)
//首页统计
export const reqOrder = () => ajax(baseUrl + '/api/v1/p/summary/order');
export const reqWayOrder = () => ajax(baseUrl + '/api/v1/p/summary/wayOrder');
export const reqAnalysis = (optType) => ajax(baseUrl + '/api/v1/p/summary/analysis', {optType});
export const reqWarnings = (po) => ajax(baseUrl + '/api/v1/p/summary/warnings', po);

export const reqOptTypes = (po) => ajax(baseUrl + '/api/v1/p/order/optTypes', po);
export const reqOrderAnalysis = (po) => ajax(baseUrl + '/api/v1/p/order/analysis', po);
export const reqOrderMonthAnalysis = (po) => ajax(baseUrl + '/api/v1/p/order/monthAnalysis', po);
//预警备注说明
export const reqOrderNoteList = (po) => ajax(baseUrl + '/api/v1/p/orderWarningNoteList', po);
export const reqDelOrderNoteList = (po) => ajax(baseUrl + '/api/v1/p/orderWarningNote', po, 'DELETE');
export const reqSaveOrderNoteList = (po) => ajax(baseUrl + '/api/v1/p/orderWarningNote', po, 'POST');
export const reqUpdateOrderNoteList = (po) => ajax(baseUrl + '/api/v1/p/orderWarningNote', po, 'PUT');
//委托协议，舱单管理，货物清单管理(数据过多优化:详情分页查询，修改删除新增均调用接口)
export const getPackages = (po) => ajax(baseUrl + '/api/v1/p/oms/packageManages', po)
export const savePackage = (po) => ajax(baseUrl + '/api/v1/p/oms/packageManage', po, 'POST')
export const updatePackage = (po) => ajax(baseUrl + '/api/v1/p/oms/packageManage', po, 'PUT')
export const delPackage = (id, orderId) => ajax(baseUrl + '/api/v1/p/oms/packageManage', {id, orderId}, 'DELETE')
//报关单
export const reqGetDeclares = (po) => ajax(baseUrl + '/api/v1/p/oms/declare/declares', po)
//租还箱
export const reqRentalBox = (type) => ajax(baseUrl + '/api/v1/p/rentalBox', {type});
//关口
export const reqCustomsPorts = (po) => ajax(baseUrl + '/api/v1/p/getCustomsPorts', po);
//贸易类型
export const reqBusiness = (customsPort, deliveryType) => ajax(baseUrl + '/api/v1/p/business', {
    customsPort, deliveryType
});
//转关运输：报关地
export const reqDeclareCities = (declareCity) => ajax(baseUrl + '/api/v1/p/getCustomsCity', {declareCity});
export const reqCabinetTypes = (deliveryType) => ajax(baseUrl + '/api/v1/p/cabinetTypes', {deliveryType});
//包装种类
export const reqPackageCodes = () => ajax(baseUrl + '/api/v1/p/packageCodes',);
//货物类型
export const reqBusinessAll = (noMulti) => ajax(baseUrl + '/api/v1/p/businessAll', {noMulti});
//剩余舱位查询
export const reqCabinInfoStock = (po) => ajax(baseUrl + '/api/v1/p/oms/cabinInfo/stock', po);
//取消时间查询
export const reqCabinInfoCancelTime = () => ajax(baseUrl + '/api/v1/p/oms/cabinInfo/cancelTime',);
//是否需要上传凭证
export const reqPayInfo = (po) => ajax(baseUrl + '/api/v1/p/oms/payInfo', po);
//班次时间查询
export const reqPlanList = (deliveryType) => ajax(baseUrl + '/api/v1/p/oms/orderTransport/planList', {deliveryType});
//车型
export const reqVehicleTypes = (po) => ajax(baseUrl + '/api/v1/p/oms/entVehicle/info', po);
//车型及剩余数量
export const reqVehicleStock = (po) => ajax(baseUrl + '/api/v1/p/oms/entVehicle/stock', po);
// 条形码信息
export const reqBarcodeInfos = (po) => ajax(baseUrl + '/api/v1/p/barcode/barcodeInfoList', po);
export const reqCreateBarcode = (po) => ajax(baseUrl + '/api/v1/p/barcode/barcodeInfo', po, 'POST');
export const reqUpdateBarcode = (po) => ajax(baseUrl + '/api/v1/p/barcode/barcodeInfo', po, 'PUT');
export const reqBarcodeInfo = (id) => ajax(baseUrl + '/api/v1/p/barcode/barcodeInfo', {id});
//账单管理
export const reqReceivableBills = (po) => ajax(baseUrl + '/api/v1/p/receivable/bills', po);
export const reqRealTimeList = (po) => ajax(baseUrl + '/api/v1/p/feeRealtime/realTimeList', po);
//货物体积(CBM)
export const reqUpdateVolume = (po) => ajax(baseUrl + '/api/v1/p/oms/volumeSave', po, 'PUT');
//铁路企业订舱管理
export const reqTrainInfo = (po) => ajax(baseUrl + '/api/v1/p/oms/train/priority/info', po);
export const reqTrainView = (po) => ajax(baseUrl + '/api/v1/p/oms/train/priority/view', po);

//公共参数：国内运输
export const reqGnVehicleTypes = () => ajax(baseUrl + '/api/v1/p/gnVehicleType');
export const reqGnGoodsTypes = () => ajax(baseUrl + '/api/v1/p/gnGoodsType');
export const reqGnPackageTypes = () => ajax(baseUrl + '/api/v1/p/gnPackageType');
export const reqGnArea = (po) => ajax(baseUrl + '/api/v1/p/gnArea', po);
//国内运输订单
export const getGnOrders = (po) => ajax(baseUrl + '/api/v1/p/gnOrder/orderList', po)
export const getGnOrder = (id) => ajax(baseUrl + '/api/v1/p/gnOrder/order', {id})
export const reqCreateGnOrder = (po) => ajax(baseUrl + '/api/v1/p/gnOrder/order', po, 'POST');
export const reqUpdateGnOrder = (po) => ajax(baseUrl + '/api/v1/p/gnOrder/order', po, 'PUT');
//国内订单: 跟踪信息管理
export const reqGnDelivery = (orderId) => ajax(baseUrl + '/api/v1/p/gn/orderDelivery', {orderId})
export const reqCreateGnDelivery = (po) => ajax(baseUrl + '/api/v1/p/gn/orderDelivery', po, 'POST');
export const reqUpGnDeliveryOther = (po) => ajax(baseUrl + '/api/v1/p/gn/orderDelivery/other', po, 'PUT');
export const reqUpdateGnDelivery = (po) => ajax(baseUrl + '/api/v1/p/gn/orderDelivery', po, 'PUT');
// 国内时间维护
export const reqGnOrderOptDt = (po) => ajax(baseUrl + '/api/v1/p/gnOpt/orderOpt', po, 'POST');
export const reqGnOrderReason = (po) => ajax(baseUrl + '/api/v1/p/gnOpt/orderReason', po, 'POST'); // 审核失败
export const reqGnOrderUpdateDt = (po) => ajax(baseUrl + '/api/v1/p/gn/orderUpdateDt', po, 'PUT'); // 修改预计抵达时间
export const reqGnOrderReasons = (orderId, optType) => ajax(baseUrl + '/api/v1/p/gnOpt/orderReasons', {
    orderId,
    optType
});
//
export const getGnOrderNodes = (orderId) => ajax(baseUrl + '/api/v1/p/gnOpt/orderOpts', {orderId})
export const reqGnRecordUpdate = (po) => ajax(baseUrl + '/api/v1/p/gnOpt/orderOpt', po, 'PUT');
export const reqGnRecordDel = (po) => ajax(baseUrl + '/api/v1/p/gnOpt/orderOpt', po, 'DELETE2');

//****  进口   ****//
//口岸
export const reqImportCustomsPorts = (deliveryType) => ajax(baseUrl + '/api/v1/p/import/getCustomsPorts', {deliveryType});
//车型
export const reqImportVehicleTypes = () => ajax(baseUrl + '/api/v1/p/import/vehicleTypes');
//进口订单
export const getImportOrders = (po) => ajax(baseUrl + '/api/v1/p/oms/importOrder/orderList', po)
export const reqImportOrder = (id) => ajax(baseUrl + '/api/v1/p/oms/importOrder/order', {id})
export const reqCreateImportOrder = (po) => ajax(baseUrl + '/api/v1/p/oms/importOrder/order', po, 'POST');
export const reqUpdateImportOrder = (po) => ajax(baseUrl + '/api/v1/p/oms/importOrder/order', po, 'PUT');
export const reqCancelImportOrder = (po) => ajax(baseUrl + '/api/v1/p/oms/importOrder/order/cancel', po, 'POST');
export const reqImportPackages = (po) => ajax(baseUrl + '/api/v1/p/oms/importOrder/packageList', po)
export const reqOrderRemarks = (id) => ajax(baseUrl + '/api/v1/p/oms/importOrder/orderRemark', {id});
export const reqOrderFileFlag = (orderId) => ajax(baseUrl + '/api/v1/p/oms/importOrder/orderFile/flag', {orderId});
// 进口物流信息列表
export const reqImportDeliveryList = (data) => ajax(baseUrl + '/api/v1/p/oms/importOrderDelivery/list', data);
export const reqImportOrderVehicles = (po) => ajax(baseUrl + '/api/v1/p/importOrder/vehicle', po)